import { default as CustomLoggedInUserView } from '../views/LoggedInUserView';
import { Customization, css } from '@eduvision/toolkit';

export const LoggedInUserView: Customization['LoggedInUserView'] = {
	component: CustomLoggedInUserView,
};
